import { isPreProdEnvironment } from "src/environmentInfo/EnvironmentInfo";

/**
 * Application-level feature flags.
 * Flags gated by environment will be enabled in local/alpha/beta
 * and disabled in gamma/prod until ready for production rollout.
 *
 */
export const FeatureFlags = {
  /** Enable the WC Canada (Sedgwick Canada) claim form. in alpha, beta and gamma. */
  wcCanadaForm: isPreProdEnvironment(),
};
